/* import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

import Reload from "../../components/Reload/Reload";
import ApiMServer from "../../services/ApiMServer";
import ApiGServer from "../../services/ApiGServer";
import Grafico from "./components/Grafico";

const Mufl = () => {
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [company, setCompany] = useState({});
  const [progress, setProgress] = useState(0);
  const [reload, setReload] = useState(false);
  const [detailsEquip, setDetailsEquip] = useState([]);

  const reloadRef = useRef(reload);

  const handleCompany = async () => {
    try {
      let { data } = await ApiMServer.post(`/company/detail`, { id });
      localStorage.setItem('company', JSON.stringify(data));
      if (data?.equipments?.length) {
        let equip = await ApiGServer.post(`equipment/filter`, { filter: data.equipments })
        localStorage.setItem('equipments', JSON.stringify(equip));
      }
    } catch (error) {
      console.error('Erro ao buscar medidas:', error?.message);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    handleCompany();
    //----------------------------------------------------------------------
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          const currentReload = reloadRef.current;
          setReload(!currentReload);
          return 0;
        }
        return prev + 3.33;
      });
      handleCompany();
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    reloadRef.current = reload;
  }, [reload]);

  return (
    <Container className="pt-2" style={{ background: '#1c4220', minHeight: "100vh" }} fluid>
      {isLoading && <Reload />}
      <Row className="mb-2 g-2">
        <Col>
          <div style={{
            width: '100%',
            backgroundColor: '#f4f4f4',
            borderRadius: '5px',
            border: "solid 1px #f4f4f4",
            overflow: 'hidden'
          }}>
            <div
              style={{
                width: `${Math.min(progress, 100)}%`,
                height: 8,
                backgroundColor: '#1c4220',
                borderRadius: '5px',
                transition: 'width 1s linear',
              }}
            ></div>
          </div>
        </Col>
      </Row>
      <Row className="g-2">
        {detailsEquip?.length && company?.equipments?.map((serial) => (
          <Grafico
            key={serial}
            company={company}
            serial={serial}
            reload={reload}
            detailsEquip={detailsEquip}
          />
        ))}
      </Row>
    </Container>
  );
};

export default Mufl;




 */

import React, { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { MdOutlineMemory, MdWavingHand, MdRefresh } from "react-icons/md";
import { WiHumidity } from "react-icons/wi";

import ApiMServer from "../../services/ApiMServer";
import ApiGServer from "../../services/ApiGServer";

import Reload from "../../components/Reload/Reload";
import Grafico from "./components/Grafico";
import { useParams } from "react-router-dom";

import "./Mufl.css"; // Importando o CSS

const Mufl = () => {
  const { id } = useParams();

  const companyLocal = JSON.parse(localStorage.getItem('company')) || {};
  const equipmentsLocal = JSON.parse(localStorage.getItem('equipments')) || [];
  
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setProgress] = useState(0);
  const [reload, setReload] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());
  const [isRefreshing, setIsRefreshing] = useState(false);

  const reloadRef = useRef(reload);

  const handleCompany = async () => {
    try {
      setIsRefreshing(true);
      let { data } = await ApiMServer.post(`/company/detail`, { id });
      localStorage.setItem('company', JSON.stringify(data));
      if (data?.equipments?.length) {
        let equip = await ApiGServer.post(`equipment/filter`, { filter: data?.equipments });
        localStorage.setItem('equipments', JSON.stringify(equip.data));
      }
    } catch (error) {
      console.error('Erro ao buscar dados:', error?.message);
    }
    setIsLoading(false);
    setIsRefreshing(false);
  }

  const handleForceRefresh = () => {
    setReload(!reload);
    setProgress(0);
    handleCompany();
  }

  useEffect(() => {
    handleCompany();

    // Atualizar hora atual a cada minuto
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    // Intervalo para atualizar dados a cada 2 minutos
    const dataRefreshInterval = setInterval(() => {
      handleCompany();
    }, 120000);

    // Progress bar interval - animação suave
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          const currentReload = reloadRef.current;
          setReload(!currentReload);
          return 0;
        }
        return prev + 0.333;
      });
    }, 100);

    return () => {
      clearInterval(interval);
      clearInterval(timeInterval);
      clearInterval(dataRefreshInterval);
    };
  }, []);

  useEffect(() => {
    reloadRef.current = reload;
  }, [reload]);

  const formatDate = () => {
    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return currentTime.toLocaleDateString('pt-BR', options);
  }

  return (
    <div style={{
      background: "linear-gradient(135deg, #121212 0%, #1e1e1e 100%)",
      minHeight: "100vh",
      padding: "20px 0",
      color: "#e0e0e0"
    }}>

      <Container fluid className="px-3">

        {isLoading && <Reload />}

        <Card className="mb-3 shadow border-0 dark-card" style={{ borderRadius: "16px", overflow: "hidden", backgroundColor: "#282c34" }}>
          <Card.Body className="p-3">
            <Row className="align-items-center">
              <Col lg={6} md={12} className="mb-md-3 mb-lg-0">
                <h2 className="dashboard-title mb-0">
                  <MdWavingHand className="icon-wave" onClick={() => { window.history.back() }} />
                  <span>Monitoramento em Tempo Real</span>
                </h2>
              </Col>
              <Col lg={6} md={12} className="text-lg-end text-center">
                <div className="d-flex justify-content-lg-end justify-content-center align-items-center gap-3 flex-wrap">
                  <span
                    className="dashboard-date"
                    onClick={handleForceRefresh}
                  >
                    {formatDate()}
                  </span>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        <div className="progress-container mb-4">
          <div
            className="progress-bar"
            style={{
              width: `${Math.min(progress, 100)}%`,
              transition: `width 0.1s linear`
            }}
          ></div>
        </div>

        <div className="dashboard-stats mb-4">
          <Row className="g-3">
            <Col lg={6} md={6} sm={12}>
              <Card className="dashboard-stat-card h-100">
                <Card.Body className="d-flex align-items-center p-4">
                  <div className="stat-icon">
                    <MdOutlineMemory />
                  </div>
                  <div className="stat-info">
                    <h3 className="dark-text">{equipmentsLocal?.length || 0}</h3>
                    <p className="dark-text-secondary">Equipamentos Conectados</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <Card className="dashboard-stat-card h-100">
                <Card.Body className="d-flex align-items-center p-4">
                  <div className="stat-icon">
                    <WiHumidity />
                  </div>
                  <div className="stat-info">
                    <h3 className="dark-text">{companyLocal?.name || "Empresa"}</h3>
                    <p className="dark-text-secondary">Monitoramento Ativo</p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        <h4 className="section-title mb-3">Equipamentos Monitorados</h4>

        <Row className="equipment-grid g-3">
          {equipmentsLocal?.length > 0 && companyLocal?.equipments?.map((serial) => (
            <Grafico
              key={serial}
              company={companyLocal}
              serial={serial}
              reload={reload}
              detailsEquip={equipmentsLocal}
            />
          ))}

          {(!equipmentsLocal || equipmentsLocal.length === 0) && !isLoading && (
            <Col xs={12}>
              <Card className="text-center p-5 border-0 shadow-sm dark-card" style={{ borderRadius: "16px" }}>
                <Card.Body>
                  <h4 className="dark-text">Nenhum equipamento encontrado</h4>
                  <p className="text-muted dark-text-secondary">Não há equipamentos configurados para monitoramento.</p>
                  <Button
                    className="refresh-button mt-3"
                    onClick={handleForceRefresh}
                  >
                    Verificar Novamente
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Mufl;
